import { getYearMonth } from "../calendar";
import fetchJson from '../lib/react-admin-loopback/fetch';
import { addDashToDateString } from '../calendar';
import { stringify } from "query-string";

export async function reqSchedules(dataProvider, startDate, endDate) {
  return await dataProvider.getList('schedules', {
    pagination: { page: 1 },
    sort: { field: 'date', order: 'ASC' },
    queryParams: { 
      startDate,
      endDate
    }
  });
}

export async function reqSuggestion(firstDateOfMonth, orders) {
  
  // filtering TODO 

  // build order data 
  const schedules = buildSchedules(orders);
  
  // sort ? 

  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/schedules/curationAll`;
  const options = {
    method: 'POST',
    body: JSON.stringify({
      yearMonth: getYearMonth(firstDateOfMonth),
      orders: schedules 
    })
  };
  const { json } = await fetchJson(url, options);
  return { 
    data: json 
  };
}

export async function reqUpdateSchedules(schedules) {
  const url = `${process.env.REACT_APP_FCS_API_URL}/schedules`;
  const options = {
    method: 'PATCH',
    body: JSON.stringify(schedules)
  };
  const { json } = await fetchJson(url, options);
  return {
    data: json
  };
}

export async function reqSaveSchedule(orders) {

  // build body data 
  const schedules = buildSchedules(orders);

  // convert date format 
  schedules.forEach(s => {
    s.date = addDashToDateString(s.date);
    s.menu.forEach(m => m.date = addDashToDateString(m.date));
  });

  // request 
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/schedules/bulkInsert`;
  const options = {
    method: 'POST',
    body: JSON.stringify(schedules)
  };
  const { json } = await fetchJson(url, options);
  return {
    data: json
  };
}

function buildSchedules(orders) {
  const schedules = [];
  orders.forEach(el => {
    el.menu.forEach(m => {
      let found = schedules.find(s => 
        s.customerId === el.customerId && s.date === m.date);
      if (!found) {
        found = {
          date: m.date,
          customerId: el.customerId,
          customerName: el.customerName,
          deliveryGroup: el.deliveryGroup,
          menu: []
        };
        schedules.push(found);
      }

      found.menu.push({
        id: m.id ?? null,
        published: m.published ?? false,
        lock: m.lock ?? false,
        date: m.date,
        serviceTime: el.serviceTime,
        customerId: el.customerId,
        supplierId: m.supplierId,
        menuType: m.menuType,
        menuId: m.menuId,
        menuName: m.menuName,
        menuCategory: m.menuCategory ?? [],
        serviceType: m.serviceType ?? [],
        subMenu: m.subMenu ?? [],
        pickupTime: m.pickupTime,
        orderQty: m.orderQty ?? null,
        memo: m.menu ?? null
      });
    });
  });
  return schedules;
}

export async function reqCustomerAddresses(idList) {
  const apiUrlBase = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      fields: {
        id: true, address: true
      },
      where: {
        id: {
          inq: idList
        }
      }
    }),
    clientType: 'bo'
  };
  const url = `${apiUrlBase}/customers?${stringify(params)}`;
  const { json } = await fetchJson(url);
  return {
    data: json
  };
}